import { render, staticRenderFns } from "./fate-accelerated.vue?vue&type=template&id=5f5f1cb8&scoped=true&"
import script from "./fate-accelerated.vue?vue&type=script&lang=js&"
export * from "./fate-accelerated.vue?vue&type=script&lang=js&"
import style0 from "./fate-accelerated.vue?vue&type=style&index=0&id=5f5f1cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5f1cb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f5f1cb8')) {
      api.createRecord('5f5f1cb8', component.options)
    } else {
      api.reload('5f5f1cb8', component.options)
    }
    module.hot.accept("./fate-accelerated.vue?vue&type=template&id=5f5f1cb8&scoped=true&", function () {
      api.rerender('5f5f1cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/sheets/fate-accelerated.vue"
export default component.exports